import styled from 'styled-components';
import Alert from '../../Alert';
var ModalAlert = styled(Alert).withConfig({
  displayName: "Alertstyles__ModalAlert",
  componentId: "sc-p6qwrp-0"
})(["margin:var(--dentsu-spacing-24) var(--dentsu-spacing-48) 0;"]);
export var Styled = {
  ModalAlert: ModalAlert
};